import { Component, EventEmitter, Inject, Input, OnInit, Output, DestroyRef, inject } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { ComissaoJulgadoraService } from '../comissao-julgadora-service'
import { DadosTermoConflito, DadosTermoConflitoDeInteresseDTO } from 'src/app/models/registro-de-acordo-examinador'
import { MatDialogRef } from '@angular/material/dialog'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

export interface DeclarationDialogData {
  comissaoJulgadoraId: number
  token: string
}

interface DeclarationDialogFormType {
  nome: FormControl<string>
  nacionalidade: FormControl<string>
  profissao: FormControl<string>
  residencia: FormControl<string>
  possuiConflito: FormControl<boolean | null>
  justificativa: FormControl<string>
  cienciaDados: FormControl<boolean>
}

export interface DeclarationDialogOutput extends DeclarationDialogData {
  nome: string
  nacionalidade: string
  profissao: string
  residencia: string
  possuiConflito: boolean
  justificativa: string
  cienciaDados: boolean
}

@Component({
  selector: 'inscricoes-declaration',
  templateUrl: './declaration.component.html',
  styleUrls: ['./declaration.component.scss'],
})
export class DeclarationComponent implements OnInit {
  private destroyRef = inject(DestroyRef)

  declarationForm: FormGroup<DeclarationDialogFormType>
  @Output() completed = new EventEmitter<DadosTermoConflito>()

  info?: DadosTermoConflitoDeInteresseDTO
  @Input() externalLoading?: boolean // opcional

  constructor(
    private fb: FormBuilder,
    private comissaoJulgadoraService: ComissaoJulgadoraService,
    @Inject(MAT_DIALOG_DATA) public data: DeclarationDialogData,
    private dialogRef: MatDialogRef<DeclarationComponent, DeclarationDialogOutput>
  ) {
    this.declarationForm = this.fb.group<DeclarationDialogFormType>({
      nome: this.fb.nonNullable.control('', { validators: [Validators.required] }),
      nacionalidade: this.fb.nonNullable.control('', { validators: [Validators.required] }),
      profissao: this.fb.nonNullable.control('Docente', { validators: [Validators.required] }),
      residencia: this.fb.nonNullable.control('', { validators: [Validators.required] }),
      possuiConflito: this.fb.nonNullable.control(null, { validators: [Validators.required] }),
      justificativa: this.fb.nonNullable.control({ value: '', disabled: true }, { validators: [Validators.required] }),
      cienciaDados: this.fb.nonNullable.control(false, { validators: [Validators.requiredTrue] }),
    })

    this.declarationForm.get('possuiConflito')?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
      const justificativaControl = this.declarationForm.get('justificativa')
      if (value === true) {
        justificativaControl?.enable()
      } else {
        justificativaControl?.disable()
        justificativaControl?.reset()
      }
    })
  }

  ngOnInit(): void {
    this.comissaoJulgadoraService
      .buscarDadosTermoConflitoInteresse({
        comissaoJulgadoraId: this.data.comissaoJulgadoraId,
        token: this.data.token,
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(res => {
        this.declarationForm.patchValue({ nome: res.nomeExaminador })
        this.info = res
      })
  }

  assinarDeclaracao() {
    let termoConflito: DadosTermoConflito = {
      nome: this.info?.nomeExaminador ?? '',
      nacionalidade: this.declarationForm.get('nacionalidade')?.value ?? '',
      profissao: this.declarationForm.get('profissao')?.value ?? '',
      residencia: this.declarationForm.get('residencia')?.value ?? '',
      tipoConcurso: this.info?.tipoConcurso ?? '',
      unidadeConcurso: this.info?.unidadeConcurso ?? '',
      processoSigadConcurso: this.info?.processoSigadConcurso ?? '',
      possuiConflito: this.declarationForm.get('possuiConflito')?.value ?? false,
      justificativa: this.declarationForm.get('justificativa')?.value,
    }

    this.completed.emit(termoConflito)
  }

  now() {
    return new Date()
  }
}
